// extracted by mini-css-extract-plugin
export default {"form":"Checkout_form__uC4yj","control":"Checkout_control__cFwem","actions":"Checkout_actions__b4T8w","submit":"Checkout_submit__j6R0l","invalid":"Checkout_invalid__odBlC"};